// import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
// import { useState } from "react";
// import { createPaymentIntent } from "../../../../../services/paymentService";
// import { createBooking } from "../../../../../services/bookingService";
// import { Link } from "react-router-dom";
// import Invoice from "../../../../../Pages/User/invoice";

// const styles = {
//   page: {
//     minHeight: "50vh",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     background: "#f9fafb", // gray-50
//   },
//   form: {
//     width: "100%",
//     maxWidth: "420px",
//     padding: "24px",
//     background: "#ffffff",
//     borderRadius: "12px",
//     boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
//   },
//   title: {
//     marginBottom: "16px",
//     fontSize: "20px",
//     fontWeight: "600",
//     color: "#111827", // gray-900
//   },
//   cardWrapper: {
//     padding: "12px",
//     border: "1px solid #d1d5db", // gray-300
//     borderRadius: "8px",
//     marginBottom: "16px",
//   },
//   button: {
//     width: "100%",
//     padding: "12px",
//     background: "#2563eb", // blue-600
//     color: "#fff",
//     border: "none",
//     borderRadius: "8px",
//     fontSize: "16px",
//     fontWeight: "600",
//     cursor: "pointer",
//   },
//   error: {
//     color: "#dc2626",
//     marginBottom: "12px",
//     fontSize: "14px",
//   },
//   success: {
//     color: "#16a34a",
//     marginBottom: "12px",
//     fontSize: "14px",
//   },
// };

// const cardStyle = {
//   style: {
//     base: {
//       color: "#1f2937", // gray-800
//       fontSize: "16px",
//       fontFamily: "Inter, system-ui, sans-serif",
//       fontSmoothing: "antialiased",
//       "::placeholder": {
//         color: "#9ca3af", // gray-400
//       },
//     },
//     invalid: {
//       color: "#dc2626", // red-600
//     },
//   },
// };


// export default function CheckoutForm({ bookingData }) {
//   const stripe = useStripe();
//   const elements = useElements();

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [success, setSuccess] = useState(false);
//   const [booking, setBooking] = useState();

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!stripe || !elements) return;

//     setLoading(true);
//     setError(null);

//     // 1. Ask backend to create PaymentIntent
//     createPaymentIntent(bookingData.totalPrice / 2).then(async (res) => {
//       const { clientSecret } = res;

//       // 2. Confirm payment
//       const result = await stripe.confirmCardPayment(clientSecret, {
//         payment_method: {
//           card: elements.getElement(CardElement),
//         },
//       });

//       if (result.error) {
//         setError(result.error.message);
//       } else {
//         if (result.paymentIntent.status === "succeeded") {
//           setSuccess(true);
//           createBooking(bookingData).then((res) => {
//             setBooking(res);
//           });
//         }
//       }
//     })

//     setLoading(false);
//   };

//   return (
//     <div style={styles.page}>
//       {success ? (
//         <div style={styles.form}>
//           <h2 style={styles.title}>Successful!</h2>
//           <p>The Payment was successful and The Tour has been booked.</p>
//           <p>You can download the invoice here! <Invoice bookingId={booking.id} /> </p>
//           <p>You can see your bookings here! <Link to={'/my-bookings'}>My Bookings</Link> </p>
//         </div>
//       ) : (
//         <div style={styles.form}>
//           <h2 style={styles.title}>Amount: ${bookingData.totalPrice}</h2>
//           <p>You have to make an advance payment of 50% of the total amount.</p>
//           <div style={styles.cardWrapper}>
//             <CardElement options={cardStyle} />
//           </div>

//           {error && <p style={styles.error}>{error}</p>}

//           <button
//             disabled={!stripe || loading}
//             style={{
//               ...styles.button,
//               opacity: loading ? 0.7 : 1,
//             }}
//             onClick={handleSubmit}
//           >
//             {loading ? "Processing…" : `Pay $${bookingData.totalPrice / 2}`}
//           </button>
//         </div>
//       )}
//     </div>
//   );
// }
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { useState, useEffect } from "react";
import { 
  FaCreditCard, 
  FaLock, 
  FaShieldAlt, 
  FaCheckCircle, 
  FaReceipt,
  FaArrowRight,
  FaUser,
  FaCalendarAlt,
  FaUsers,
  FaTag
} from "react-icons/fa";
import { 
  FiCreditCard, 
  FiLock, 
  FiCheck, 
  FiAlertCircle,
  FiDownload,
  FiArrowRight,
  FiCalendar,
  FiUser,
  FiUsers,
  FiDollarSign
} from "react-icons/fi";
import { createPaymentIntent } from "../../../../../services/paymentService";
import { createBooking } from "../../../../../services/bookingService";
import { Link } from "react-router-dom";
import Invoice from "../../../../../Pages/User/invoice";
import "./PaymentForm.scss";

export default function CheckoutForm({ bookingData }) {
  const stripe = useStripe();
  const elements = useElements();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [booking, setBooking] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState("idle");
  const [paymentMethod, setPaymentMethod] = useState("card");

  // Calculate amounts
const totalAmount = bookingData?.amount * bookingData?.people || 0;
const discount = bookingData.people >= 6 ? bookingData.people * 60 :
                 bookingData.people >= 4 ? bookingData.people * 50 : 0;
const totalAfterDiscount = totalAmount - discount;
const depositAmount = Math.round(totalAfterDiscount * 0.5);
const balanceAmount = totalAfterDiscount - depositAmount;


  useEffect(() => {
    if (bookingData) {
      console.log("Booking data received:", bookingData);
    }
  }, [bookingData]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      setError("Payment system is not ready. Please try again.");
      return;
    }

    if (!bookingData || !bookingData.totalAmount) {
      setError("Booking information is incomplete. Please go back and try again.");
      return;
    }

    setLoading(true);
    setError(null);
    setPaymentStatus("processing");

    try {
      // 1. Ask backend to create PaymentIntent
      const res = await createPaymentIntent(depositAmount);
      
      if (!res.clientSecret) {
        throw new Error("Payment initialization failed. Please try again.");
      }

      const { clientSecret } = res;

      // 2. Confirm payment
      const result = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: elements.getElement(CardElement),
          billing_details: {
            name: bookingData.fullName || "",
            email: bookingData.email || "",
            phone: bookingData.phone || ""
          }
        },
        receipt_email: bookingData.email || undefined
      });

      if (result.error) {
        setError(result.error.message);
        setPaymentStatus("error");
      } else {
        if (result.paymentIntent.status === "succeeded") {
          setPaymentStatus("success");
          setSuccess(true);
          
          // Create booking record
          try {
            const bookingRes = await createBooking({
              ...bookingData,
              paymentId: result.paymentIntent.id,
              paymentStatus: "completed",
              depositPaid: depositAmount,
              balanceDue: balanceAmount
            });
            setBooking(bookingRes);
          } catch (bookingError) {
            console.error("Booking creation error:", bookingError);
            // Don't show error to user if payment succeeded
          }
        }
      }
    } catch (err) {
      setError(err.message || "Payment failed. Please try again.");
      setPaymentStatus("error");
    } finally {
      setLoading(false);
    }
  };

  // Render success state
  if (success) {
    return (
      <div className="payment-success">
        <div className="success-icon">
          <FaCheckCircle />
        </div>
        
        <div className="success-content">
          <h2>Payment Successful! 🎉</h2>
          <p className="success-message">
            Your booking has been confirmed and your adventure is now secured!
          </p>
          
          <div className="booking-summary-card">
            <div className="summary-header">
              <FaReceipt />
              <h3>Booking Summary</h3>
            </div>
            
            <div className="summary-details">
              <div className="detail-item">
                <FiUser />
                <span>Booking ID:</span>
                <strong>{booking?.id || "PENDING"}</strong>
              </div>
              <div className="detail-item">
                <FiCalendar />
                <span>Trip Date:</span>
                <strong>{bookingData?.date || "N/A"}</strong>
              </div>
              <div className="detail-item">
                <FiUsers />
                <span>Travelers:</span>
                <strong>{bookingData?.people || 1} person(s)</strong>
              </div>
              <div className="detail-item">
                <FiDollarSign />
                <span>Deposit Paid:</span>
                <strong className="amount">${depositAmount}</strong>
              </div>
              <div className="detail-item">
                <FiDollarSign />
                <span>Balance Due:</span>
                <strong className="balance">${balanceAmount}</strong>
              </div>
            </div>
          </div>

          <div className="next-steps">
            <h4>What's Next?</h4>
            <div className="steps">
              <div className="step">
                <span className="step-number">1</span>
                <div>
                  <strong>Confirmation Email</strong>
                  <p>We've sent booking details to {bookingData?.email || "your email"}</p>
                </div>
              </div>
              <div className="step">
                <span className="step-number">2</span>
                <div>
                  <strong>Pre-trip Information</strong>
                  <p>You'll receive detailed trip information 2 weeks before departure</p>
                </div>
              </div>
              <div className="step">
                <span className="step-number">3</span>
                <div>
                  <strong>Balance Payment</strong>
                  <p>Remaining balance due 30 days before your trip</p>
                </div>
              </div>
            </div>
          </div>

          <div className="action-buttons">
            <a href="#" className="btn-secondary">
              <FiDownload /> Download Invoice
              {booking?.id && <Invoice bookingId={booking.id} />}
            </a>
            <Link to="/my-bookings" className="btn-primary">
              View My Bookings <FiArrowRight />
            </Link>
            <button className="btn-outline" onClick={() => window.print()}>
              Print Confirmation
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Render payment form
  return (
    <div className="payment-form-container">
      {/* Payment Header */}
      <div className="payment-header">
        <div className="header-icon">
          <FaCreditCard />
        </div>
        <div className="header-content">
          <h2>Secure Payment</h2>
          <p>Complete your booking with a secure payment</p>
        </div>
      </div>

      {/* Payment Summary */}
      <div className="payment-summary-card">
        <div className="summary-header">
          <h3>Payment Summary</h3>
          <span className="badge">Deposit Required</span>
        </div>
        
        <div className="summary-details">
          <div className="detail-row">
            <span>Trip:</span>
            <span className="trip-name">{bookingData?.tripName || "Adventure Trip"}</span>
          </div>
          <div className="detail-row">
            <span>Total Amount:</span>
            <span className="amount">${totalAmount}</span>
          </div>
          <div className="detail-row">
            <span>Deposit (50%):</span>
            <span className="deposit">${depositAmount}</span>
          </div>
          <div className="detail-row">
            <span>Balance Due:</span>
            <span className="balance">${balanceAmount}</span>
          </div>
          <div className="detail-row total">
            <span>Amount to Pay Now:</span>
            <span className="total-amount">${depositAmount}</span>
          </div>
        </div>

        <div className="deposit-note">
          <FiAlertCircle />
          <p>50% deposit secures your booking. Balance due 30 days before departure.</p>
        </div>
      </div>

      {/* Payment Methods */}
      <div className="payment-methods">
        <div className="methods-header">
          <h3>Select Payment Method</h3>
        </div>
        
        <div className="method-options">
          <button 
            className={`method-option ${paymentMethod === "card" ? "active" : ""}`}
            onClick={() => setPaymentMethod("card")}
          >
            <FiCreditCard />
            <span>Credit/Debit Card</span>
            <div className="card-icons">
              <span className="card-icon visa">VISA</span>
              <span className="card-icon mastercard">MC</span>
              <span className="card-icon amex">AX</span>
            </div>
          </button>
          
          <button 
            className={`method-option ${paymentMethod === "paypal" ? "active" : ""}`}
            onClick={() => setPaymentMethod("paypal")}
            disabled
          >
            <img src="/paypal-icon.svg" alt="PayPal" className="paypal-icon" />
            <span>PayPal</span>
            <span className="coming-soon">Coming Soon</span>
          </button>
        </div>
      </div>

      {/* Card Payment Form */}
      {paymentMethod === "card" && (
        <form className="card-payment-form" onSubmit={handleSubmit}>
          <div className="form-section">
            <h4>
              <FiCreditCard /> Card Details
            </h4>
            
            <div className="card-input-wrapper">
              <div className="input-label">
                <span>Card Number</span>
                <div className="card-icons-inline">
                  <span className="card-icon-small visa">VISA</span>
                  <span className="card-icon-small mastercard">MC</span>
                  <span className="card-icon-small amex">AX</span>
                </div>
              </div>
              <div className="card-element-container">
                <CardElement 
                  options={{
                    style: {
                      base: {
                        fontSize: '16px',
                        color: '#1f2937',
                        fontFamily: 'Inter, system-ui, sans-serif',
                        '::placeholder': {
                          color: '#9ca3af',
                        },
                      },
                      invalid: {
                        color: '#ef4444',
                      },
                    },
                    hidePostalCode: true,
                  }}
                />
              </div>
            </div>

            <div className="card-details-grid">
              <div className="form-group">
                <label>Cardholder Name</label>
                <input 
                  type="text" 
                  placeholder="Name on card"
                  defaultValue={bookingData?.fullName || ""}
                  readOnly
                  className="readonly-input"
                />
              </div>
            </div>
          </div>

          {/* Security Info */}
          <div className="security-info">
            <div className="security-badge">
              <FaLock />
              <div>
                <strong>256-bit SSL Encryption</strong>
                <p>Your payment information is secure</p>
              </div>
            </div>
            
            <div className="security-badge">
              <FaShieldAlt />
              <div>
                <strong>PCI DSS Compliant</strong>
                <p>We never store your card details</p>
              </div>
            </div>
          </div>

          {/* Error Display */}
          {error && (
            <div className="error-alert">
              <FiAlertCircle />
              <span>{error}</span>
            </div>
          )}

          {/* Loading State */}
          {paymentStatus === "processing" && (
            <div className="processing-indicator">
              <div className="spinner"></div>
              <span>Processing your payment...</span>
              <p>Please don't close this window</p>
            </div>
          )}

          {/* Submit Button */}
          <button
            type="submit"
            disabled={!stripe || loading || paymentStatus === "processing"}
            className="submit-payment-btn"
          >
            {loading || paymentStatus === "processing" ? (
              <>
                <div className="btn-spinner"></div>
                Processing Payment...
              </>
            ) : (
              <>
                <FiLock />
                Pay ${depositAmount} Now
                <FiArrowRight />
              </>
            )}
          </button>

          <div className="payment-terms">
            <p>
              By completing this payment, you agree to our{" "}
              <a href="/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>{" "}
              and confirm that all information provided is accurate.
            </p>
            <p className="refund-note">
              <FiAlertCircle /> Deposits are refundable up to 60 days before departure.
            </p>
          </div>
        </form>
      )}

      {/* PayPal Form (Placeholder) */}
      {paymentMethod === "paypal" && (
        <div className="paypal-placeholder">
          <div className="placeholder-content">
            <img src="/paypal-logo.svg" alt="PayPal" className="paypal-logo" />
            <p>PayPal payment option will be available soon.</p>
            <button 
              className="btn-outline"
              onClick={() => setPaymentMethod("card")}
            >
              Use Card Payment Instead
            </button>
          </div>
        </div>
      )}
    </div>
  );
}